import React from "react";
import { AlertTriangleIcon } from "lucide-react";

const MissingPromptTemplateNotice = () => (
  <div className="flex shrink-0 items-start gap-2.5 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 text-amber-900">
    <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
    <div className="min-w-0">
      <p className="text-xs font-medium">This sheet can’t be evaluated</p>
      <p className="mt-0.5 text-xs leading-5 text-amber-700">
        It doesn’t contain a Prompt Template column. Add one to the sheet, or reference a different
        sheet above.
      </p>
    </div>
  </div>
);

export default MissingPromptTemplateNotice;
